<main class="chat-auth">
  <div class="card chat-auth__card mb-0">
    <div class="card-body p-4 text-center">
      <div class="auth-brand mb-3">
        <img src="assets/images/logo-dark.svg" class="logo-dark chat-auth__logo mx-auto" alt="Trendmulti" />
        <img src="assets/images/logo.svg" class="logo-light chat-auth__logo mx-auto" alt="Trendmulti" />
      </div>
      <div class="avatar-md mx-auto mb-3">
        <span class="avatar-title rounded-circle bg-soft-warning text-warning font-24">
          <i class="ri-chat-off-line" aria-hidden="true"></i>
        </span>
      </div>
      <h4 class="mt-0">{{ 'chatApp.unavailable.title' | translate }}</h4>
      <p class="text-muted">{{ messageKey | translate }}</p>
      <a class="btn btn-primary w-100 mb-2" [href]="productUrl">
        <i class="ri-arrow-left-line me-1" aria-hidden="true"></i>{{ 'chatApp.common.backToProduct' | translate }}
      </a>
      @if (session.isAuthenticated()) {
        <button type="button" class="btn btn-light w-100" (click)="signOut()">
          {{ 'chatApp.common.signOut' | translate }}
        </button>
      }
    </div>
  </div>
</main>
